import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import LazyImages from '../../../components/lazy-images';
import { Breakpoint } from '../../../types/breakpoint';
export default class VeevOneSlider {
    static $slider = $('.js__veev-one-slider');
    static slider;
    static options = {
        modules: [Navigation],
        slidesPerView: 'auto',
        loop: false,
        centeredSlides: true,
        spaceBetween: 22,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            [Breakpoint.md]: {
                spaceBetween: 74,
            },
        },
    };
    static init() {
        if (!this.$slider.length) {
            return;
        }
        this.slider = new Swiper(this.$slider.get(0), {
            ...this.options,
        });
        LazyImages.update();
    }
}
